export const SidebarData1 = {
  rollcall: [
    {
      tittle: "Employee",
      hasSubRoute: true,
      icon: "users",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Attendance",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/attendance",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "Leave Management",
      hasSubRoute: true,
      icon: "calendar",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "My Leaves",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/leaves",
          subRoutes: [],
        },
        {
          tittle: "Leave Summary",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/leaveaccurals",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "My Team",
      hasSubRoute: true,
      icon: "users",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Team Members",
          hasSubRoute: false,
          showSubRoute: false,
          route: "rollcall/teammembers",
          subRoutes: [],
        },
        {
          tittle: "Manual Attendance",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/manualattendance",
          subRoutes: [],
        },

        {
          tittle: "Monthly Attendance",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/monthlyattendance",
          subRoutes: [],
        },
        {
          tittle: "Bulk Attendace",
          hasSubRoute: false,
          showSubRoute: false,
          route: "rollcall/bulkattendance",
          subRoutes: [],
        },
        {
          tittle: "Team Leaves",
          hasSubRoute: false,
          showSubRoute: false,
          route: "rollcall/leaveapplication",
          subRoutes: [],
        },
      ],
    },
  ],
};
